import { BoldText } from 'ui/theme';

import { TOGGLE_MODAL_DISPLAY_TEXT, TOGGLE_MODAL_TYPE } from '../../constants';
import { WorkflowNameData } from '../../types';

type ToggleWorkflowPromptProps = {
  workflows: WorkflowNameData[];
  toggleType: TOGGLE_MODAL_TYPE;
};

export const ToggleWorkflowPrompt = ({ workflows, toggleType }: ToggleWorkflowPromptProps) => {
  const isBulk = workflows.length > 1;
  return (
    <p>
      Are you sure you want to {TOGGLE_MODAL_DISPLAY_TEXT.verb[toggleType].toLowerCase()}{' '}
      {isBulk ? 'these' : ''}{' '}
      <BoldText>{isBulk ? `${workflows.length} journeys` : workflows[0].name}</BoldText>?
    </p>
  );
};
